import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import home from './Home.module.css';
import styles from './HomeAppCoverage.module.css';

/**
 * EAA-1814 (S3 rebuild — canonical frame 09): "Phủ vai trò theo app" (frame 09
 * lines 790-910) — per-app role-coverage bars ("Content Studio 4/5", "LMS
 * 3/5", …) plus a "Trung bình phủ 47%" summary.
 *
 * NOT BUILT with real bars: `GET /dashboard` (see `useDashboard.ts`, read
 * against `DashboardService` in emg-ai-content-hub-be) returns exactly one
 * role-map-related figure — the ecosystem/org-scoped COUNT of paused links
 * (`attention[type=role_map_paused].count`) — never a per-application
 * breakdown of "N of M standard roles linked". Rendering the frame's bars
 * would mean inventing a ratio per app, which the "never invented" rule in
 * the ticket explicitly forbids. The card shell (title/sub, matching frame
 * geometry) is kept so the dashboard's layout rhythm is unchanged; the body
 * is an explicit "not available" state rather than a fake bar or an
 * indefinite skeleton.
 *
 * Gated on `console.rolemap.view` — the same capability that would back this
 * data if a per-app endpoint existed.
 */
export function HomeAppCoverage({ can }: { can: (key: string) => boolean }) {
    const { t } = useTranslation();
    if (!can('console.rolemap.view')) {
        return null;
    }

    return (
        <div className={`${home.card} ${styles.card}`}>
            <div className={home.cardHeadText}>
                <h3 className={home.cardTitle}>{t('home.appCoverage.title')}</h3>
                <span className={home.cardSub}>{t('home.appCoverage.subtitle')}</span>
            </div>
            <div className={home.unavailable}>
                <span className={home.unavailableNote}>
                    {/* EAA-1845: sentence kept whole via Trans (rather than split into
                        several t() calls) so translators see the real word order; the
                        vi/en key values still carry the <code>/<link> tags inline. */}
                    <Trans
                        i18nKey="home.appCoverage.unavailableNote"
                        components={{
                            code: <code className={home.unavailableCode} />,
                            link: <Link to="/console/role-map" className={home.unavailableLink} />,
                        }}
                    />
                </span>
            </div>
        </div>
    );
}

export default HomeAppCoverage;
